import { render, staticRenderFns } from "./EdmDetail.vue?vue&type=template&id=21ffd84c&scoped=true"
import script from "./EdmDetail.vue?vue&type=script&lang=js"
export * from "./EdmDetail.vue?vue&type=script&lang=js"
import style0 from "./EdmDetail.vue?vue&type=style&index=0&id=21ffd84c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ffd84c",
  null
  
)

export default component.exports